/** * 左边菜单 */
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" text-color="#000">
    <div @click="gohome" class="logobox" :style="{ width: collapsed ? '64px' : '200px' }">
      <el-image class="logoimg" :src="logo || '../../static/logo.png'" fit="cover"></el-image>
      <span v-if="!collapsed">{{ $store.state.shop_data.name }}</span>
    </div>
    <div style="height: 60px;background: #1F2227;"></div>
    <template v-if="$store.state.nav_status == 0">
      <div v-for="(item, index) in menulist" :key="item.rule_id">
        <el-menu-item v-if="item.type=='menu'" :index="item.path" :key="index.toString()">
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </el-menu-item>
        <el-submenu v-if="item.type == 'menu_dir'" :index="index.toString() ">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <div v-for="(inner, index1) in item.child" :key="inner.rule_id">
            <el-menu-item :index="inner.path" :key="index1.toString()">
              <i :class="inner.icon"></i>
              <span>{{ inner.title }}</span>
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </template>
    <template v-if="$store.state.nav_status == 1">
      <div v-for="(item, index) in menulist1" :key="item.rule_id">
        <el-menu-item v-if="item.type == 'menu'" :index="item.path" :key="index.toString()">
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </el-menu-item>
        <el-submenu v-if="item.type == 'menu_dir'" :index="(index + 1000).toString()">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <div v-for="(inner,index1) in item.child" :key="inner.rule_id">
            <el-menu-item :index="inner.path" :key="index1.toString()">
              <i :class="inner.icon"></i>
              <span>{{ inner.title }}</span>
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </template>
    <template v-if="$store.state.nav_status==4">
      <div v-for="(item, index) in menulist2" :key="item.rule_id">
        <el-menu-item v-if="item.type == 'menu'" :index="item.path" :key="index">
          <i :class="item.icon"></i>
          <span>{{ item.title}}</span>
        </el-menu-item>
        <el-submenu v-if="item.type == 'menu_dir'" :index="index + 1024">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <div v-for="(inner,index1) in item.child" :key="inner.rule_id">
            <el-menu-item :index="inner.path" :key="index1">
              <i :class="inner.icon"></i>
              <span>{{ inner.title}}</span>
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </template>
    <template v-if="$store.state.nav_status==5">
      <div v-for="(item, index) in menulist3" :key="item.rule_id">
        <el-menu-item v-if="item.type == 'menu'" :index="item.path" :key="index">
          <i :class="item.icon"></i>
          <span>{{ item.title}}</span>
        </el-menu-item>
        <el-submenu v-if="item.type == 'menu_dir'" :index="index + 2199">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <div v-for="(inner,index1) in item.child" :key="inner.rule_id">
            <el-menu-item :index="inner.path" :key="index1">
              <i :class="inner.icon"></i>
              <span>{{ inner.title}}</span>
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </template>
      <template v-if="$store.state.nav_status==6">
      <div v-for="(item, index) in menulist4" :key="item.rule_id">
        <el-menu-item v-if="item.type == 'menu'" :index="item.path" :key="index">
          <i :class="item.icon"></i>
          <span>{{ item.title}}</span>
        </el-menu-item>
        <el-submenu v-if="item.type == 'menu_dir'" :index="index + 1499">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <div v-for="(inner,index1) in item.child" :key="inner.rule_id">
            <el-menu-item :index="inner.path" :key="index1">
              <i :class="inner.icon"></i>
              <span>{{ inner.title}}</span>
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </template>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG';
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      menulist: [],
      menulist1: [],
      menulist2: [],
      menulist3: [],
      menulist4: [],
      shop: {},
      logo: ''
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.$get(this.$api.shopInfo).then(res => {
      if (res.status == 200) {
        this.logo = res.data.logo
      }
    })
    // 获取列表
    JSON.parse(localStorage.getItem('menuList')).forEach(item => {
      if (item.rule_id == 107) {
        this.menulist = item.child
      } else if (item.rule_id == 1000) {
        this.menulist1 = item.child
      } else if (item.rule_id == 1025) {
        this.menulist2 = item.child
      } else if (item.rule_id == 1500) {
        this.menulist3 = item.child
      } else if (item.rule_id == 2200) {
        this.menulist4 = item.child
      }
    })
    // 监听
    this.$root.Bus.$on('toggle', (value) => {
      this.collapsed = !value;
    });
  },
  methods: {
    gohome() {
      this.$router.replace(`/reflushPage?redirect=${this.$route.path}`);
    }
  }
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #1F2227;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

.logoimg {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.logobox span {
  color: #9d9d9d;
  font-size: 16px;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue